import React from 'react';
import { DataProviderVesselReporting } from '../../store';
import { ScenarioProvider } from '../../../../shared/contexts/ScenarioContext';

const withDataProvider = (Component) => (props) => (
  <ScenarioProvider>
    <DataProviderVesselReporting>
      <Component {...props} />
    </DataProviderVesselReporting>
  </ScenarioProvider>
);

export default withDataProvider;
